import {createAction} from '@reduxjs/toolkit';
import {OrderingFilters, PaginatedTableFilters} from 'store/home/type';

export const enum GESTIONE_ACCESSI_TABLE_ACTION {
    SET_PAGE_INDEX = 'GESTIONE_ACCESSI_SET_PAGE_INDEX',
    SET_PAGE_SIZE = 'GESTIONE_ACCESSI_SET_PAGE_SIZE',
    SET_SEARCH_TABLE_DATA = 'GESTIONE_ACCESSI_SET_SEARCH_TABLE_DATA',
    SET_FILTERS = 'GESTIONE_ACCESSI_SET_FILTERS',
    SET_ORDERING_FILTERS = 'GESTIONE_ACCESSI_SET_ORDERING_FILTERS',
}

const setPageIndexAction = createAction(GESTIONE_ACCESSI_TABLE_ACTION.SET_PAGE_INDEX, (payload:number) => {
    return {payload}
})

const setPageSizeAction = createAction(GESTIONE_ACCESSI_TABLE_ACTION.SET_PAGE_SIZE, (payload:number) => {
    return {payload}
})

const setFiltersAction = createAction(GESTIONE_ACCESSI_TABLE_ACTION.SET_FILTERS, (payload:PaginatedTableFilters) => {
    return {payload}
})
const setOrderingFiltersAction = createAction(GESTIONE_ACCESSI_TABLE_ACTION.SET_ORDERING_FILTERS, (payload:OrderingFilters) => {
    return {payload}
})

export const GestioneAccessiTableAction = {
    setPageIndexAction,
    setPageSizeAction,
    setFiltersAction,
    setOrderingFiltersAction
};
